import { render } from "./SelectAutoUploader.vue?vue&type=template&id=05c243ee&scoped=true"
import script from "./SelectAutoUploader.vue?vue&type=script&lang=js"
export * from "./SelectAutoUploader.vue?vue&type=script&lang=js"

import "./SelectAutoUploader.vue?vue&type=style&index=0&id=05c243ee&scoped=true&lang=css"
import "./SelectAutoUploader.vue?vue&type=style&index=1&id=05c243ee&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c243ee"],['__file',"src/components/SelectAutoUploader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05c243ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05c243ee', __exports__)) {
    api.reload('05c243ee', __exports__)
  }
  
  module.hot.accept("./SelectAutoUploader.vue?vue&type=template&id=05c243ee&scoped=true", () => {
    api.rerender('05c243ee', render)
  })

}


export default __exports__